// node:stream/promises stand-in — pipelines to nowhere; download IPC is
// fused off in the web build.
module.exports = {
    pipeline: () =>
        Promise.reject(
            new Error("stream pipelines are fused off in the web build"),
        ),
    finished: () => Promise.resolve(),
};
